import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';

export interface ExportOptions {
  includeBatesCitations: boolean;
}

interface ExportOptionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onExport: (options: ExportOptions) => void;
}

export const ExportOptionsDialog = ({
  open,
  onOpenChange,
  onExport,
}: ExportOptionsDialogProps) => {
  const [includeBatesCitations, setIncludeBatesCitations] = useState(true);

  const handleExport = () => {
    onExport({ includeBatesCitations });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Export Options</DialogTitle>
          <DialogDescription>
            Configure how your document will be exported to Word.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="flex items-start space-x-3">
            <Checkbox
              id="include-bates"
              checked={includeBatesCitations}
              onCheckedChange={(checked) =>
                setIncludeBatesCitations(checked === true)
              }
            />
            <div className="grid gap-1.5 leading-none">
              <Label
                htmlFor="include-bates"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Include Bates citations
              </Label>
              <p className="text-sm text-muted-foreground">
                When enabled, citations will be rendered as Bates numbers (e.g.,
                SMITH0001) in the exported document. When disabled, citations
                will be removed from the export.
              </p>
            </div>
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleExport}>Export to Word</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
